<template>
  <div id="indexApp" align="center">
    <h3>Search the Site Index</h3>
    <label for="searchBox">Index Search</label>&nbsp;<input id="searchBox" type="text" v-model="tempTerm" />&nbsp;<button v-on:click="setSearchTerm">Search</button>
    <br /><p> - OR -</p>
    <h3>Browse the Site Index by letter</h3>
    <ul class="azLinks">
      <li v-for="letter in letters" v-bind:class="{'selected': letter.letter === selectedLetter}">
        <a v-on:click="setLetter">{{ letter.letter }}</a>
      </li>
    </ul>
    <h4 v-if="selectedLetter && indexLinks.length > 0">{{ selectedLetter }}</h4>
    <h4 v-else-if="searchTerm && indexLinks.length > 0">Search results for {{ searchTerm }}</h4>
    <h4 v-else-if="selectedLetter && indexLinks.length === 0"><strong>No matches found for {{ selectedLetter}}</strong></h4>
    <h4 v-else-if="searchTerm && indexLinks.length === 0"><strong>No matches found for {{ searchTerm }}</strong></h4>
    <p v-show="errorMsg">{{ errorMsg }}</p>
    <ul class="indexLinks">
      <li v-for="link in indexLinks">
        <a :href="link.url">{{ link.title}}</a>
      </li>
    </ul>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SiteIndex',
  data () {
    return {
      selectedLetter: '',
      searchTerm: '',
      tempTerm: '',
      errorMsg: '',
      letters: [
          { letter: 'A' },
          { letter: 'B' },
          { letter: 'C' },
          { letter: 'D' },
          { letter: 'E' },
          { letter: 'F' },
          { letter: 'G' },
          { letter: 'H' },
          { letter: 'I' },
          { letter: 'J' },
          { letter: 'K' },
          { letter: 'L' },
          { letter: 'M' },
          { letter: 'N' },
          { letter: 'O' },
          { letter: 'P' },
          { letter: 'Q' },
          { letter: 'R' },
          { letter: 'S' },
          { letter: 'T' },
          { letter: 'U' },
          { letter: 'V' },
          { letter: 'W' },
          { letter: 'X' },
          { letter: 'Y' },
          { letter: 'Z' }
      ],
      indexLinks: ''
    }
  },
  watch: {
    selectedLetter: function () {
      if (this.selectedLetter === null || this.selectedLetter === '') {
        return
      }
      //alert('running letter watch')
      var that = this
      $.ajax({
        url: this.get_url() + '/graphql',
        data: this.get_letter_queryString(),
        method: 'post',
      }).done(function(response) {
        console.log(response)
        that.indexLinks = response['data'].letterSearch
      }).fail(function(response) {
        console.log(error)
        that.errorMsg = 'Error generating link list. Please contact <a href="mailto:webmaster@frostburg.edu">webmaster</a>'
      });  
    },
    searchTerm: function () {
      if (this.searchTerm === null || this.searchTerm === '') {
        return
      }
      //alert('running search watch')
      var that = this
      $.ajax({
        url: this.get_url() + '/graphql',
        data: this.get_search_queryString(),
        method: 'post',
      }).done(function(response) {
        console.log(response)
        that.indexLinks = response['data'].termSearch

      }).fail(function(response) {
        console.log(error)
        that.errorMsg = 'Error generating link list. Please contact <a href="mailto:webmaster@frostburg.edu">webmaster</a>'
      }); 
    }
  },
  methods: {
    setLetter: function (event) {
      this.searchTerm = ''
      this.tempTerm = ''
      this.selectedLetter = event.target.innerHTML
    },
    setSearchTerm: function (event) {
      if (this.tempTerm === null || this.tempTerm === '') {
        return
      }
      this.selectedLetter = ''
      this.searchTerm = this.tempTerm
    },
    get_url: function () {
      var url = window.location.hostname
      var ret = ''
      if (url === 'localhost' || url === '127.0.0.1') {
        ret = 'http://127.0.0.1:8000'
      } else if (url === 'internal.frostburg.edu') {
        ret = 'http://internal.frostburg.edu'
      } else {
        ret = 'https://www.frostburg.edu'
      }
      return ret
    },
    get_letter_queryString: function () {
      return `query=query {
               letterSearch(browseLetter: "${this.selectedLetter}") {
                 title,
                 url
               }
              }`
    },
    get_search_queryString: function () {
      return `query=query {
               termSearch(searchTerm: "${this.searchTerm}") {
                 title,
                 url
               }
              }`
    }
  },
  mounted: function() {
    this.selectedLetter = 'A'
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.azLinks {
  list-style-type: none !important;
  padding: 0;
  text-align: center;
  border-top: 2px solid #ccc;
  border-bottom: 2px solid #ccc;
  max-width: 720px;
}
.azLinks > li {
  display: inline-block;
  margin: 0;
}
.azLinks > li > a {
  display: inline-block;
  color: black;
  padding: .5em;
}
.azLinks > li > a:hover {
  text-decoration: underline;
  background-color: #ccc;
}
.selected > a {
  background-color: #f00033 !important;
  color: white !important;
}
.leftAlign {
  text-align: left;
}
.indexLinks {
  list-style-position: inside;
  padding: 0px;
}

</style>



// WEBPACK FOOTER //
// src/components/SiteIndex.vue